import type { ExportInput } from './types';

/** Serialise the full skim state as a JSON Blob. */
export function generateJson(input: ExportInput): Blob {
  const payload = {
    schemaVersion: '0.0.1',
    generatedAt: input.generatedAt,
    skimReportId: input.skimReportId,
    fileName: input.fileName,
    manuscript: {
      title: input.manuscript.title,
      contentHash: input.manuscript.contentHash,
      authorSurnames: input.manuscript.authorSurnames,
      affiliations: input.manuscript.affiliations,
      wordCount: input.manuscript.wordCount,
      pages: input.manuscript.pages.length,
      extractorVersion: input.manuscript.extractorVersion,
    },
    pattern: {
      classifier: input.pattern.classifier,
      methodology: input.pattern.methodology,
      findings: input.pattern.findings,
      numbers: input.pattern.numbers,
      references: input.pattern.references,
      keywords: input.pattern.keywords,
    },
    referenceAudit: input.referenceAudit,
    reviewers: input.reviewers,
    draft: input.draft,
  };
  return new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
}
